export default __webpack_public_path__ + "static/media/Eye.e0d6639a.svg";